import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Layout } from '@/components/layout/Layout.tsx';
import { LeftSidebar } from '@/components/sections/LeftSidebar.tsx';
import { RCA8310ProductShowcase } from '@/components/sections/RCA8310ProductShowcase.tsx';
import { RCA1510ProductShowcase } from '@/components/sections/RCA1510ProductShowcase.tsx';
import { Mini6ProductShowcase } from '@/components/sections/Mini6ProductShowcase.tsx';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>The Kelly Manufacturing Company, the manufacturer of RC Allen Instruments for general aviation.</title>
        <meta name="description" content="Kelly Manufacturing Company is the manufacturer of RC Allen Instruments for general aviation. We specialize in attitude indicators, directional indicators, turn indicators, and digital aviation instruments." />
        <meta name="keywords" content="aviation instruments, RC Allen, Kelly Manufacturing, attitude indicators, turn indicators, directional indicators, RCA8310, RCA1510, Mini6, general aviation, aircraft instruments" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        
        {/* Open Graph meta tags */}
        <meta property="og:title" content="The Kelly Manufacturing Company, the manufacturer of RC Allen Instruments for general aviation." />
        <meta property="og:description" content="Kelly Manufacturing Company is the manufacturer of RC Allen Instruments for general aviation. We specialize in attitude indicators, directional indicators, turn indicators, and digital aviation instruments." />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Kelly Manufacturing Company" />
        
        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="The Kelly Manufacturing Company, the manufacturer of RC Allen Instruments for general aviation." />
        <meta name="twitter:description" content="Kelly Manufacturing Company is the manufacturer of RC Allen Instruments for general aviation. We specialize in attitude indicators, directional indicators, turn indicators, and digital aviation instruments." />
        
        {/* Additional meta tags */}
        <meta name="author" content="Kelly Manufacturing Company" />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="30 days" />
      </Helmet>
      
      <Layout>
        <div className="flex">
          {/* Left Sidebar */}
          <LeftSidebar />
          
          {/* Main Content Area */}
          <div className="flex-1 p-6">
            {/* Welcome Section */}
            <div className="bg-white rounded-lg shadow p-8 mb-8">
              <h1 className="text-3xl font-bold text-rcallen-primary-blue font-arial mb-4">
                Welcome to {siteData.title}
              </h1>
              <p className="text-rcallen-black font-arial">
                RC Allen Instruments - Aviation instruments manufactured by Kelly Manufacturing Company
              </p>
            </div>

            {/* RCA8310 Product Showcase */}
            <RCA8310ProductShowcase />
            
            {/* RCA1510 Product Showcase */}
            <RCA1510ProductShowcase />
            
            {/* Mini6 Product Showcase */}
            <Mini6ProductShowcase />
          </div>
        </div>
      </Layout>
    </>
  );
}